import { computed, inject, Injectable, signal } from '@angular/core';
import { IAuthProvider } from '@modules/auth/domain/providers/auth.provider';
import { IAccountInfo } from '@modules/auth/domain/models/auth-session.model';
import { AUTH_PROVIDER } from '@modules/auth/di';

@Injectable({ providedIn: 'root' })
export class AuthSessionService {
  private readonly auth = inject<IAuthProvider>(AUTH_PROVIDER);
  private readonly _account = signal<IAccountInfo | null>(
    this.auth.getCurrentAccount(),
  );

  readonly userId = computed(() => this._account()?.localAccountId ?? '');
  readonly userName = computed(() => this._account()?.username ?? '');

  get currentUser(): IAccountInfo | null {
    return this._account();
  }

  getUserId(): string {
    return this.userId();
  }

  getUserName(): string {
    return this.userName();
  }

  refresh(): void {
    this._account.set(this.auth.getCurrentAccount());
  }
}
